import { render, staticRenderFns } from "./ListOrderPromotion.vue?vue&type=template&id=5bc795ee&scoped=true&"
import script from "./ListOrderPromotion.vue?vue&type=script&lang=js&"
export * from "./ListOrderPromotion.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=5bc795ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc795ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc795ee')) {
      api.createRecord('5bc795ee', component.options)
    } else {
      api.reload('5bc795ee', component.options)
    }
    module.hot.accept("./ListOrderPromotion.vue?vue&type=template&id=5bc795ee&scoped=true&", function () {
      api.rerender('5bc795ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Listing/ListOrderPromotion.vue"
export default component.exports